import React, {useEffect, useState} from 'react';
import {X509Certificate} from '@peculiar/x509';

import styles from './Key.module.css';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {labelStyles} from '../../../../common/styles/formStyles';
import InputLabel from '@mui/material/InputLabel';
import {format} from 'date-fns';
import {hetch} from "../../../../utils/fetch.hooked";

const aliases = {
  "CN": "2.5.4.3",
  "C": "2.5.4.6",
  "L": "2.5.4.7",
  "ST": "2.5.4.8",
  "STREET": "2.5.4.9",
  "O": "2.5.4.10",
  "OU": "2.5.4.11",
  "TITLE": '2.5.4.12',
  "DC": "0.9.2342.19200300.100.1.25",
  "E": "1.2.840.113549.1.9.1",
  "G": "2.5.4.42",
  "I": "2.5.4.43",
  "SN": "2.5.4.4",
  "T": "2.5.4.12",
  unstructuredName: '1.2.840.113549.1.9.2',
  OGRN: '1.2.643.100.1',
  OGRNIP: '1.2.643.100.5',
  INN: '1.2.643.3.131.1.1',
  INNLE: '1.2.643.100.4',
  SNILS: '1.2.643.100.3',
  serialNumber: '2.5.4.5',
}



const map = {
  "CN": "Общее имя",
  "C": "Страна",
  "L": "Местность",
  "ST": "Область",
  "O": "Организация",
  "OU": "Подразделение",
  "TITLE": 'Должность',
  "DC": "domainComponent",
  "E": "email",
  "G": null,
  "I": null,
  "SN": null,
  "T": null,
  "STREET": "Улица",
  unstructuredName: '1.2.840.113549.1.9.2',
  'OGRN': 'ОГРН',
  'OGRNIP': 'ОГРНИП',
  'INN': 'ИНН',
  'INNLE': 'ИНН',
  'SNILS': 'СНИЛС',
  serialNumber: 'Серийный номер',
}
const renderField = (name, fieldId) => {
  let field = name.getField(fieldId);
  if (!field.length) {
    field = name.getField(aliases[fieldId]);
  }

  if (field.length) {
    return (
      <div>
        <div><b>{map[fieldId] ?? fieldId}:</b></div>
        <div>{field.join(',')}</div>
      </div>
    );
  }
  return null;
};

function Cert({cert}) {
  return (
    <div>
      {cert.subjectName ? (
        <div>
          <div><b>Кому выдан</b></div>
          <hr/>
          <div>
            <div>
              {renderField(cert.subjectName, 'CN')}
              {renderField(cert.subjectName, 'C')}
              {renderField(cert.subjectName, 'L')}
              {renderField(cert.subjectName, 'ST')}
              {renderField(cert.subjectName, 'STREET')}
              {renderField(cert.subjectName, 'O')}
              {renderField(cert.subjectName, 'OU')}
              {renderField(cert.subjectName, 'DC')}
              {renderField(cert.subjectName, 'E')}
              {renderField(cert.subjectName, 'G')}
              {renderField(cert.subjectName, 'I')}
              {renderField(cert.subjectName, 'SN')}
              {renderField(cert.subjectName, 'T')}
            </div>
          </div>
          <br/>
        </div>
      ) : null}
      {cert.issuerName ? (
        <div>
          <div><b>Кем выдан</b></div>
          <hr/>
          <div>
            <div>
              {renderField(cert.issuerName, 'CN')}
              {renderField(cert.issuerName, 'C')}
              {renderField(cert.issuerName, 'L')}
              {renderField(cert.issuerName, 'ST')}
              {renderField(cert.issuerName, 'STREET')}
              {renderField(cert.issuerName, 'O')}
              {renderField(cert.issuerName, 'OU')}
              {renderField(cert.issuerName, 'DC')}
              {renderField(cert.issuerName, 'E')}
              {renderField(cert.issuerName, 'G')}
              {renderField(cert.issuerName, 'I')}
              {renderField(cert.issuerName, 'SN')}
              {renderField(cert.issuerName, 'T')}
            </div>
          </div>
          <br/>
        </div>
      ) : null}
      <div>
        <div><b>Срок действия</b></div>
        <hr/>
        <div>
          <div>
            <div><b>Дата начала:</b></div>
            <div>{format(cert.notBefore, 'dd.MM.yyyy HH:mm')}</div>
          </div>
          <div>
            <div><b>Дата окончания:</b></div>
            <div>{format(cert.notAfter, 'dd.MM.yyyy HH:mm')}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Key({keyName, setKeyName}) {
  const [keyCert, setKeyCert] = React.useState(null);
  const [keysList, setKeysList] = useState([]);
  useEffect(() => {
    const fetchData = () => {
      hetch('/api/key_names')
        .then(res => res.json())
        .then(res => {
          setKeysList(res?.content ?? []);
        });
    }
    fetchData();
  }, []);
  useEffect(() => {
    const fetchPublicKey = (id) => {
      hetch(`/api/keys/key-name-id/${id}/actual/public-key`)
        .then(res => {
          if (res.status === 200) {
            return res.text();
          }
          return null;
        })
        .then(res => {
          setKeyCert(res ? new X509Certificate(res) : null);
        });
    }
    if (keyName) {
      const keyItem = keysList.find((keyItem) => keyItem.key_name === keyName);
      if (keyItem) {
        fetchPublicKey(keyItem.id);
      }
    }

  }, [keyName, keysList]);
  return (
    <div className={styles.key}>
      <div className={styles.selectContainer}>
        <InputLabel htmlFor='serialNumber' sx={labelStyles} required={true}>Накладываемая подпись</InputLabel>
        <Select
          fullWidth
          size="small"
          sx={{backgroundColor: 'white'}}
          value={keyName ?? ''}
          onChange={(e) => {
            setKeyName(e.target.value);
          }}
        >
          {keysList.map(item => (
            <MenuItem
              key={item.id}
              value={item.key_name}
            >
              {item.key_name}
            </MenuItem>
          ))}
        </Select>
      </div>
      <InputLabel htmlFor='serialNumber' sx={labelStyles}>Содержание</InputLabel>
      <div className={styles.certInfo}>
        {keyCert ? <Cert cert={keyCert}/> : 'Сертификат не найден'}
      </div>
    </div>
  );
}
